export default __webpack_public_path__ + "static/media/daniel-olahs.d4a32d6f.jpg";